import Link from '@commons/components/Link';

import type { EventNodeProps } from '.';

/**
 * Event node component for the Label display type.
 */

const EventNodeLabel = ({ title, alias }: EventNodeProps) => {
  return <Link href={alias}>{title}</Link>;
};

export default EventNodeLabel;
